import React, { MouseEventHandler, PropsWithChildren, ReactNode } from 'react'
import cls from 'classnames'
import { IconS24LocationPin124 } from '@is24/cosma-ui-icons'
import styles from './ClfRealEstateCard.module.css'

type RealEstateCardProps = {
  headline: string
  src?: string
  address: string
  className: string
  onClick: MouseEventHandler<HTMLDivElement>
}

export function ClfRealEstateCard(props: PropsWithChildren<RealEstateCardProps>) {
  const { headline, src, address, children, className, onClick } = props

  const hostClassNames = cls(className, styles['real-estate-card'])

  return (
    <div className={hostClassNames} onClick={onClick}>
      {src ? <img className={styles.image} src={src} alt={headline} /> : null}
      <div className={styles.body}>
        <div className={styles.container}>
          <TextSection text={{ title: headline, subtitle: address }}>{children}</TextSection>
        </div>
      </div>
    </div>
  )
}

function TextSection(props: {
  children: ReactNode
  text: {
    title: string
    subtitle: string
  }
}) {
  const { text, children } = props
  return (
    <div className='grid-item one-whole custom-font-regular-color padding-m'>
      <div className='grid grid-flex grid-align-center grid-justify-space-between'>
        <h5 className='grid-item font-ellipsis margin-none'>{text.title}</h5>
        <div className='grid grid-flex one-whole'>
          <div className='grid grid-flex grid-item one-whole'>
            <IconS24LocationPin124 className='font-lightgray margin-top-xs margin-right-xs' width={16} height={16} />
            <p className='font-lightgray pii-hide'>{text.subtitle}</p>
          </div>
          <div className='grid-item padding-top-m one-whole'>{children}</div>
        </div>
      </div>
    </div>
  )
}
